<template>
  <div class="flex flex-col items-center gap-6 py-6 text-subtlest" data-testid="notification-feed-empty">
    <div class="w-70 text-center">
      <p class="txt-body-s-semibold">{{ title ?? t('Dashboard.notifications.emptyState.title') }}</p>
      <p class="txt-body-s-regular">{{ body ?? t('Dashboard.notifications.emptyState.body') }}</p>
    </div>
    <div class="flex w-70 flex-col gap-1.5" aria-hidden="true">
      <NotificationPlaceholderCard v-for="(opacity, idx) in PLACEHOLDER_OPACITIES" :key="idx" :class="opacity" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import NotificationPlaceholderCard from './NotificationPlaceholderCard.vue'

defineProps<{
  title?: string
  body?: string
}>()

const PLACEHOLDER_OPACITIES = ['opacity-75', 'opacity-50']

const { t } = useI18n()
</script>
